export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.vehicles_managers) {
        return {...state, ...payload.vehicles_managers};
      }
      return state;
    }
  }
};
